<template>
    <div class="side animate-box" id="searchBox" v-if="themeLogic.search">
      <div class="parent search-width">
       <div class="input-group mb-3 d-flex ">
        <div class="input-group-prepend search-icon">
          <i class="icon-search3"></i>
        </div>
        <input type="text" @focus="focusout();" v-model="search_term" :class="{ 'red-border': showRedBorder }" id="myTextField" @keydown.enter.prevent="callAdvancedSearch()" class="form-control search-input" aria-label="search here" :placeholder="decodeHtmlLang(languageData['search'])">
 
        <div class="input-group-append">
          <button id="myBtnField" class="btn-search " @focus="btnFocus()" @click="callAdvancedSearch()">
            {{decodeHtmlLang(languageData['search'])}}
          </button>
        </div>
       </div>

       <div class="rad">
         <div class="input-radio">
           <input type="radio" id="search_title" @focus="focusoutRadio();"  name="search" v-model="search_term_title" aria-label="search on title" value="1" checked>
           <label for="search_title" class="label">{{decodeHtmlLang(languageData['search_title'])}}</label>
         </div>
         <div class="input-radio">
          <input type="radio" id="search_body" @focus="focusoutRadio2();"   name="search" @click="searchTitle()" v-model="search_term_body" aria-label="search on content" value="0">
          <label for="search_body" class="label">{{decodeHtmlLang(languageData['search_content'])}}</label>
         </div>
       </div>

      </div>
    </div>    
</template>

<script>
import axios from 'axios';

export default {
    name: 'SiteSearch',
    data(){
        return{
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN,
            //languageData:this.$store.state.languageData,
            search_term: this.$route.query.q ? this.$route.query.q : '',
            search_term_title: 1,
            search_term_body:'',
            showRedBorder: false,
            item: 1,
            search_term_title:  (this.$route.query.type === undefined) || (this.$route.query.type === 'advanced') ? 1 : 0, 
            search_term_body:  (this.$route.query.type === 'simple') ? 0 : ''
            
        };
        
    },
    computed:{
       languageData(){return this.$store.state.languageData;},
       themeLogic(){
            return this.$store.state.themeLogic.headers;
        },
   
    },
    mounted: function () {
           
    },
    created:function(){
          
    },
	  methods:{
      focusout() {
          const textField = document.getElementById('myTextField');
          const radioField1 = document.getElementById("search_title");
          const radioField2 = document.getElementById("search_body");
          const searchButton = document.getElementById("myBtnField");

          const handleKeyDown = function(event) {
              if (event.key === "Tab" && !event.shiftKey) {
                  if (document.activeElement === textField) {
                      event.preventDefault();
                      radioField1.focus();
                  }
              } else if (event.key === "ArrowUp" || "ArrowDown") {
                  if (document.activeElement === radioField2) {
                      event.preventDefault();
                      radioField1.focus();
                  }
              } else if (event.key === "ArrowUp" || "ArrowDown") {
                  if (document.activeElement === radioField1) {
                      event.preventDefault();
                      radioField2.focus();
                  }
              }
          };

        textField.addEventListener('keydown', handleKeyDown);

        textField.addEventListener('keydown', function(event) {
            if (event.key === "Enter") {
                event.preventDefault();
            }
        });

        textField.addEventListener('focusout', function() {
            textField.removeEventListener('keydown', handleKeyDown);
        });

        radioField1.tabIndex = "0";
        radioField2.tabIndex = "0";
  
   },
      focusoutRadio() {
        if (this.item === 1) {
            console.log("focus");
            const radioField1 = document.getElementById("search_title");
            const btnField = document.getElementById('myBtnField');
            radioField1.addEventListener('keydown', (event) => {
              if(event.key === "Tab"){
                event.preventDefault()
                btnField.focus();}
                radioField1.tabIndex = '-1';
            }, {});
        }
    },
      focusoutRadio2(){
        if (this.item === 1) {
              console.log("focus");
              const radioField2 = document.getElementById("search_body");
              const btnField = document.getElementById('myBtnField');
              radioField2.addEventListener('focusout', () => {
                  btnField.focus();
                  radioField1.tabIndex = '-1';
              }, {  });
          }
      },

      btnFocus() {
        const radioField1 = document.getElementById("search_title");
        const radioField2 = document.getElementById("search_body");
        const btnField = document.getElementById('myBtnField');

        btnField.addEventListener('keydown', (event) => {
            radioField2.tabIndex='-1';
        });
    
      },
      searchTitle() {
        this.search_term_title = 0;   
      },

      callAdvancedSearch(){
        if (this.search_term.trim() === '') {
          this.showRedBorder = true;
      } else {
        // Perform search logic here
          this.showRedBorder = false; // Reset the red border
      }

        if(this.search_term_title == 1 && this.search_term){
           this.$router.push({path:'/search/?q='+this.search_term+'&type=advanced'})
               // this.search_term_title = 0
        }
        else if(this.search_term_body == 0 && this.search_term){
           this.$router.push({path:'/search/?q='+this.search_term+'&type=simple'})
        }
     },

    }
};
</script>
<style scoped>
.red-border {
  border: 2px dotted red !important;
}

.search-icon{
  position: absolute;
  z-index: 99;
  top: 14px;
  left: 5px;
}

.search-input{
    border-top-left-radius: 5px !important;
    border-bottom-left-radius: 5px !important;
    border:none;
    background:#fff;
    position: relative;
    padding-left:2.5rem;
}

.form-group{
    text-align: right;
    font-size: 14px;
    padding-right: 3px;
    font-weight: normal;
}
.btn{
    border:none !important;
    padding: 12px 15px !important;
}
@media only screen  and (min-width : 992px) {
.side {
    margin-bottom: 0 !important;
}

}

.form-control{
    height: 42px !important;
    /* padding-left: 4em !important; */
}
.btn-primary{
    padding: 12px 15px !important;
}

.parent {
  width: 90%;
  float: right;
  background: #02437d;
  padding: 10px 8px 1px 8px;
  border-radius: 12px;
}
.rad {
  text-align: left;
  padding-top: inherit;
}
.search {
  width: 100%;
  overflow:hidden;
  height: 40px;
  border: 1px solid #888888;
  background: white;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  border-radius: 5px;
  padding-left: 10px;
  position: relative;
}
.text-box {
  width: 60%;
  height:100%;
  line-height: 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.text-box > i
{
  font-size:15px;
}

.search-text {
  border: none;
  width: 100% !important;
  height:100%;
  height: 30px;
  border-radius: 5px;
  padding-right: 8px;
}

.search-text:focus {
  border: none !important;
  outline: none !important;
}

.btn-search {
  background-color: #dddddd;
  width: auto;
  text-transform: uppercase;
  height: 100%;
  color: #454545;
  text-align: center;
  border-radius: 5px;
  font-weight: 600;
  padding: 0px 20px 0px 20px; 
  outline: none;
  border: none;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.5s;
  text-overflow: ellipsis;
  overflow: hidden;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  /* add this line */
}

.input-radio {
  display: inline-flex !important;
  float:inline-start;

}


.label {
  font-size: 90%;
  margin-top: 4px;
  font-weight: 200;
}

input[type=radio] {
  margin: 0px !important;
  accent-color: #7a7a7a;
}
@media only screen and (max-width: 1280px) and (min-width: 993px) {
  .text-box {
    width: 50% !important;
  }
  .btn-search{
    width: auto !important;
  }
  .parent {
    width: 100% !important;

}
}
@media only screen and (max-width: 992px) and (min-width: 768px){
  .parent {
    width: 100% !important;
  }
  .text-box {
    width: 60% !important;
  }
  .btn-search{
    width: auto !important;
  }
}
@media only screen and (max-width: 767px) and (min-width: 576px) {
  .text-box {
    width: 60% !important;
  }
  .btn-search{
    width: auto !important;
  }
  .parent {
    width: 100% !important;
  }
}
@media only screen and (max-width: 576px) {
  .text-box {
    width: 50% !important;
  }
  .btn-search{
    width: auto !important;
  }
  .parent {
    width: 100% !important;
  }
}
</style>